import baseService from './baseService';

export const getDisputes = (page, perPage, searchTerm, disputeFilters, disputePageFilter) =>
  baseService.get('/member/disputes', {
    params: {
      page,
      per_page: perPage,
      search_term: searchTerm,
      dispute_filters: disputeFilters,
      status: disputePageFilter,
    },
  });

export const getDisputeDetails = (disputeId) => baseService.get(`/member/disputes/${disputeId}`);

export const postDispute = (reason, details, payoutId) =>
  baseService.post('/member/disputes', {
    dispute: {
      reason,
      details,
      payout_id: payoutId,
    },
  });

export const postDisputeClose = (disputeId) =>
  baseService.put(`/member/disputes/${disputeId}`, {
    open: false,
  });

export const postDeclineRequestClose = (data) =>
  baseService.put(`/member/disputes/${data.disputeId}`, {
    ...data,
    open: true,
    request_to_close: false,
  });

export const getDisputeFiltersData = () => baseService.get('/member/disputes/dispute_filters');
